import '../../styles/Title.css';

export default function Title() {
    return (<div className="row justify-content-center my-5">
        <div className="col-auto">
            <h1 className='title'>
                <span className='Indiana'> Indiana </span> <span className="reference"> Data Submission Portal </span>
            </h1>
        </div>
    </div>
    );
}